export const DELETE_UA_URL_GROUP_NAME = "delete_user_analytics_url_group";
export const DELETE_UA_URL_GROUP_DESC = `Deletes a User Analytics URL group.

Use when the user asks to remove a saved URL group within a User Analytics project. Confirm the target name and project before running the mutation.

Input:
- urlGroupId (required): URL group ID to delete.
- userAnalyticsId (optional): Parent User Analytics ID, if known.
- projectId (optional): Project ID to help locate the group.
- name (optional): Friendly name to display when metadata cannot be fetched.

Output:
- Returns the deleted URL group ID, last known metadata, and resolved project/User Analytics IDs for navigation.

Notes:
- Write operation; always run through confirmation UI.
- If the ID is invalid or the group was already removed, return an error so the user can refresh.`;
